import {
  Box,
  Button,
  Center,
  Flex,
  Select,
  SimpleGrid,
  Text,
  TextInput,
} from '@mantine/core'
import { modals } from '@mantine/modals'
import LoadingSkeleton from '@v2/commons/components/LoadingSkeletonRows/LoadingSkeletonRows.component'
import { ProviderDto } from '@v2/domains/clinics/clinics.type'

import useAddDoctorLocation from '../../hook/useAddDoctorLocation.hook'
import classes from './create-provider-location-clinic-modal.module.scss'

interface addProviderMembershipLocationContentProps {
  clinicId: string
  clinicName: string
  provider?: ProviderDto
}

const AddProviderLocationClinicContent = ({
  clinicId,
  clinicName,
  provider,
}: addProviderMembershipLocationContentProps) => {
  const {
    form,
    onSubmit,
    isLoading,
    isSuccessData,
    providerData,
    locationData,
    showProviderInformation,
    handleAddManualyProvider,
    handleAutogenerateEmail,
  } = useAddDoctorLocation({ clinicId, provider })

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault()
        onSubmit()
      }}
    >
      <Center>
        <Text fz="h3" fw="bold">
          Add New Provider
        </Text>
      </Center>
      {isSuccessData ? (
        <Box p="lg">
          <SimpleGrid mb="lg" cols={2} spacing="lg">
            <TextInput
              label="Clinic Name"
              withAsterisk
              value={clinicName}
              disabled
            />

            <Select
              key={form.key('locationId')}
              label="Location"
              placeholder="Select location"
              data={locationData}
              withAsterisk
              searchable
              {...form.getInputProps('locationId')}
            />

            {!showProviderInformation && (
              <Select
                key={form.key('userId')}
                label="Provider Name"
                placeholder="Select or Enter Provider Name"
                data={providerData}
                withAsterisk
                disabled={provider?.providerId ? true : false}
                nothingFoundMessage={
                  <Box
                    onClick={() => handleAddManualyProvider()}
                    style={{ cursor: 'pointer' }}
                  >
                    <Text>
                      No provider found. <Text c="blue">Add manualy</Text>
                    </Text>
                  </Box>
                }
                searchable
                {...form.getInputProps('userId')}
              />
            )}

            <Select
              key={form.key('specialty')}
              label="Specialty"
              placeholder="Select Specialty"
              data={[
                'General and Family Dentistry',
                'Endodontist',
                'Oral and Maxillofacial Surgey',
                'Orthodontist',
                'Periodontist',
                'Prosthodontist',
              ]}
              withAsterisk
              searchable
              {...form.getInputProps('specialty')}
            />

            {showProviderInformation && (
              <>
                <TextInput
                  key={form.key('firstName')}
                  label="Fist Name"
                  placeholder="Enter Fist Name"
                  withAsterisk
                  {...form.getInputProps('firstName')}
                />

                <TextInput
                  key={form.key('lastName')}
                  label="Last Name"
                  placeholder="Enter Last Name"
                  withAsterisk
                  {...form.getInputProps('lastName')}
                />

                <Box className={classes.emailWrapper}>
                  <Button
                    className={classes.emailButton}
                    size="xs"
                    onClick={() => handleAutogenerateEmail()}
                  >
                    Autogenerate Email
                  </Button>

                  <TextInput
                    key={form.key('email')}
                    label="Email"
                    placeholder="Enter email"
                    withAsterisk
                    {...form.getInputProps('email')}
                  />
                </Box>
              </>
            )}
          </SimpleGrid>

          <Flex justify="space-between" align="center" mt="xl">
            <Button variant="outline" onClick={() => modals.closeAll()}>
              Cancel
            </Button>
            <Button type="submit" loading={isLoading}>
              Add Provider
            </Button>
          </Flex>
        </Box>
      ) : (
        <LoadingSkeleton pb={10} maxRange={5} height={10} />
      )}
    </form>
  )
}

export const openAddProviderLocationClinicModal = (
  clinicId: string,
  clinicName: string,
  provider?: ProviderDto,
) => {
  return modals.open({
    title: null,
    centered: true,
    withCloseButton: true,
    size: 'lg',
    children: (
      <AddProviderLocationClinicContent
        clinicId={clinicId}
        clinicName={clinicName}
        provider={provider}
      />
    ),
  })
}
